(() => {
  const zone = 'Europe/Paris';
  const anchor = Date.UTC(2026, 9, 8);
  const partsFormat = new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  const displayFormat = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'long', day: 'numeric', year: 'numeric' });
  const parts = date => Object.fromEntries(partsFormat.formatToParts(date).filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const orderDay = now => {
    const p = parts(now);
    return Math.max(anchor, Date.UTC(p.year, p.month - 1, p.day) - (p.hour < 12 ? 86400000 : 0));
  };
  const refresh = () => {
    const day = orderDay(new Date());
    document.querySelectorAll('[data-sg-delivery-offset]').forEach(element => {
      const offset = Number(element.dataset.sgDeliveryOffset);
      if (!Number.isInteger(offset)) return;
      const date = new Date(day + offset * 86400000);
      element.textContent = displayFormat.format(date);
      element.setAttribute('datetime', date.toISOString().slice(0, 10));
    });
  };
  const schedule = () => {
    refresh();
    const now = new Date();
    const p = parts(now);
    const target = Date.UTC(p.year, p.month - 1, p.day + (p.hour >= 12 ? 1 : 0), 12);
    let instant = target;
    for (let i = 0; i < 3; i += 1) {
      const q = parts(new Date(instant));
      instant += target - Date.UTC(q.year, q.month - 1, q.day, q.hour, q.minute, q.second);
    }
    window.setTimeout(schedule, Math.max(1000, instant - now.getTime() + 50));
  };
  schedule();
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  document.addEventListener('shopify:section:load', refresh);
})();